import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { shape, string, func, bool } from "prop-types";

import { resizableRoute } from "pages/_components/Resizable";
import { actions as layoutActions } from "reducers/layout";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import { selectors as formSelectors } from "reducers/form";
import {
    actions as transactionLinesActions,
    selectors as transactionLinesSelectors,
} from "reducers/form/transactionLines";
import { actions as massPaymentsActions } from "reducers/massPayments";

import PaymentLines from "pages/forms/PaymentLines";
import FileCollapsibleInfo from "pages/forms/_components/FileCollapsibleInfo";

class TransactionPaymentLines extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        match: shape({
            params: shape({
                idTransaction: string.isRequired,
            }).isRequired,
        }).isRequired,
        transaction: shape({}).isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(transactionLinesActions.clearTransactionLines());
        this.applyEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, match } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.match?.params?.idTransaction !== match?.params?.idTransaction)
        ) {
            this.applyEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            this.clearEmbeddedV3ShellLayout();
        }
    }

    clearEmbeddedV3ShellLayout = () => {
        const { dispatch } = this.props;
        dispatch(layoutActions.setScopes([]));
        dispatch(layoutActions.setTitleKey(""));
        dispatch(layoutActions.setHeaderTitle(""));
        dispatch(layoutActions.setHeaderSubtitle(""));
        dispatch(layoutActions.setGoBackPath(null));
        dispatch(layoutActions.setRightContentMobile(null));
    };

    applyEmbeddedV3ShellLayout = () => {
        const { embeddedInV3Shell, dispatch, isDesktop, match } = this.props;
        if (!embeddedInV3Shell || !isUxDashboardImprovementsEnabled()) {
            return;
        }
        const { idTransaction } = match.params;
        dispatch(layoutActions.setScopes(["form"]));
        if (isDesktop) {
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
            return;
        }
        dispatch(layoutActions.setHeaderTitle(""));
        dispatch(layoutActions.setTitleKey("transaction.process.details.heading.title"));
        dispatch(layoutActions.setGoBackPath(`/transaction/${idTransaction}`));
    };

    handleDownloadClick = (filterState, format) => {
        const { transaction, dispatch } = this.props;
        const { filterData } = filterState;
        dispatch(massPaymentsActions.downloadLinesRequest(transaction.idTransaction, format, filterData));
    };

    render() {
        const { embeddedInV3Shell, ...rest } = this.props;
        return (
            <PaymentLines
                isEditingPayment={false}
                renderMoreDetails={() => <FileCollapsibleInfo />}
                onDownloadClick={this.handleDownloadClick}
                formats={["xls", "txt"]}
                embeddedInV3Shell={embeddedInV3Shell}
                {...rest}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    transaction: formSelectors.getTransaction(state),
    transactionLines: transactionLinesSelectors.getTransactionLines(state),
    totalAmount: transactionLinesSelectors.getTotalAmount(state),
    totalLines: transactionLinesSelectors.getTotalLines(state),
    paymentCurrency: transactionLinesSelectors.getCurrency(state),
    isFetching: formSelectors.getFetching(state),
    isLastPage: transactionLinesSelectors.isLastPage(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(TransactionPaymentLines);
